export default __webpack_public_path__ + "static/insurances-f43709d0ab19bb699d37d7491baa9d9a.png";